export const SINGLE_LOCATION = 'SINGLE_SERVICE_LOCATION' as const;
export const DEALER_GROUP = 'DEALER_GROUP' as const;
export const FLEET = 'FLEET' as const;
export const DEALER_TEAM = 'DEALER_TEAM' as const;
export const DEALER_ID = 'DEALER_ID' as const;

export const QA = 'QA';
export const DEMO = 'DEMO';
export const POC = 'POC';
export const PAYING_CUSTOMER = 'PAYING_CUSTOMER';

export const MANAGED_CARE = 'MANAGED_CARE';
export const LEASING_AND_RENTAL = 'LEASING_AND_RENTAL';
export const MIXED = 'MIXED';

export const PLATFORM_ACCOUNT_TYPES = {
  DEALER_ID: 'DEALER_ID',
  DEALER_GROUP: 'DEALER_GROUP',
} as const;
